import firebase from "firebase/app";
import "firebase/analytics";

export const logEvent = (name: string, data?: { [key: string]: string | number | boolean | undefined }) => {
    firebase.apps.length && firebase.analytics().logEvent(name, data);
}